
import axios from '../config/axios';

export const url = '/api/curriculumvitae7pd8o'


export const createcurriculumvitae7pd8o = ({
  token,
	nombrecg40ki,
	apellidorr7ioj,
	correoivr4r,
	telefonowi3hj,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrecg40ki && apellidorr7ioj && correoivr4r && telefonowi3hj ) {
		const formData = new FormData();
		formData.append('loftyFile', loftyFile);
		formData.append('nombrecg40ki', nombrecg40ki);
		formData.append('apellidorr7ioj', apellidorr7ioj);
		formData.append('correoivr4r', correoivr4r);
		formData.append('telefonowi3hj', telefonowi3hj);

    axios.post(`${url}//create/basic/690d21f6e30724925007123d`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',

        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrecg40ki) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!apellidorr7ioj) {
		reject({
			status: 'error',
			info: 'Apellido no esta definido',
		});
	}  else if (!correoivr4r) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!telefonowi3hj) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

